import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Settings } from '../../../../core/settings';
import { FileToLanguage } from '../../../../covance-file-upload/covance-file-upload.component';
import { CultureInfo } from '../../../../core/culture-info';
import { Observable } from 'rxjs';
import { Category, CategoryNaturalKey } from '../../../../documents';
import { ActivityLogger } from '../../../../activities/activity-logger';

@Injectable()
export class UploadedTranslationsStorage {

    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings,
        private readonly activityLogger: ActivityLogger,
    ) { }

    public upload(files: FileToLanguage, categoryId: CategoryNaturalKey, documentId: string): Observable<HttpEvent<Object>> {
        this.activityLogger.logAddTranslationsActivity(documentId);

        const languages: CultureInfo[] = [];
        const fileContent = files.keys();

        const formData: FormData = new FormData();

        for (let file of fileContent) {
            formData.append('file', file, file.name);
            languages.push(files.get(file));
        }

        formData.append('fileLanguages', JSON.stringify(languages));
        formData.append('documentId', documentId);

        const apiPath = Category.isELearningCategory(categoryId) ? 'e-learning' : 'upload-documents';
        const url = `${this.settings.apiUrl}/admin/${apiPath}/${categoryId}/upload-translations/${documentId}`;
        const request = new HttpRequest('POST', url, formData, { reportProgress: true });

        return this.http.request(request);
    }
}